module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-menu', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "mode": "horizontal",
      "default-active": _vm.activeIndex,
      "background-color": "#252a2f",
      "text-color": "#fff",
      "active-text-color": "#ffd04b"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "0"
    }
  }, [_c('el-popover', {
    attrs: {
      "placement": "bottom",
      "width": "300",
      "trigger": "hover"
    }
  }, [_c('ul', {
    staticClass: "msgUL"
  }, _vm._l((_vm.msgPage.data), function(r) {
    return _c('li', {
      key: r.id,
      on: {
        "click": function($event) {
          return _vm.onMsgClick(r.id)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      }
    }, [_vm._v(_vm._s(r.title))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#a0a0a0",
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(r.msgOn))])])
  }), 0), _vm._v(" "), (_vm.msgPage.total < 1) ? _c('el-alert', {
    attrs: {
      "title": ""
    }
  }, [_vm._v("暂无")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/msg"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    }
  }, [_vm._v("更多")])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [(_vm.msgPage.total > 0) ? _c('el-badge', {
    attrs: {
      "value": _vm.msgPage.total
    }
  }, [_c('icon', {
    attrs: {
      "name": "bell-fill",
      "scale": "2"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.msgPage.total < 1) ? _c('icon', {
    attrs: {
      "name": "bell-fill",
      "scale": "2"
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.user.headerImg),
      expression: "!user.headerImg"
    }],
    attrs: {
      "name": "account",
      "scale": "2"
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.headerImg),
      expression: "user.headerImg"
    }],
    staticClass: "headerImg",
    attrs: {
      "src": _vm.user.headerImg
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.user.username))])], 1), _vm._v(" "), _c('el-menu-item-group', [_c('template', {
    slot: "title"
  }, [_vm._v("--- 系统设置 ---")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "2-3"
    },
    on: {
      "click": _vm.onModifyPwd
    }
  }, [_vm._v("修改密码")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "2-4"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("退出登录")])], 2)], 2)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "个人信息",
      "visible": _vm.personalInfoShowFlag,
      "width": "50%"
    },
    on: {
      "update:visible": function($event) {
        _vm.personalInfoShowFlag = $event
      }
    }
  }, [_c('personal-info', {
    ref: "personalInfoForm"
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "密码修改",
      "visible": _vm.resetPwdDiagShowFlag,
      "width": "50%"
    },
    on: {
      "update:visible": function($event) {
        _vm.resetPwdDiagShowFlag = $event
      }
    }
  }, [_c('modify-pwd-panel', {
    ref: "modifyPwdPanel",
    on: {
      "saved": _vm.onModifyOk
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54845ada","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/layout/NavPanel/index.vue
// module id = 338
// module chunks = 0